export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TabVerificaTratta.vue?vue&type=template&id=76b9ebc4&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabVerificaTratta.vue?vue&type=template&id=76b9ebc4&
// module id = 838
// module chunks = 0